var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearcheBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7802 16.7198L12.6615 11.601C13.653 10.3763 14.25 8.82 14.25 7.12501C14.25 3.19651 11.0535 0 7.12498 0C3.19648 0 0 3.19648 0 7.12498C0 11.0535 3.19651 14.25 7.12501 14.25C8.82 14.25 10.3763 13.653 11.601 12.6615L16.7198 17.7802C16.866 17.9265 17.058 18 17.25 18C17.442 18 17.634 17.9265 17.7803 17.7802C18.0735 17.487 18.0735 17.013 17.7802 16.7198ZM7.12501 12.75C4.023 12.75 1.50001 10.227 1.50001 7.12498C1.50001 4.02296 4.023 1.49998 7.12501 1.49998C10.227 1.49998 12.75 4.02296 12.75 7.12498C12.75 10.227 10.227 12.75 7.12501 12.75Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearcheBlueIcon);
export default __webpack_public_path__ + "static/media/searche-blue-icon.b200422081f6225291bee8bf49709899.svg";
export { ForwardRef as ReactComponent };